import { useEffect, useRef, useState } from 'react'
import { useTranslate } from '../../TranslationsContext'
import './Marquee.css'

export function Marquee() {
  const translate = useTranslate()
  const ref = useRef<HTMLParagraphElement>(null)
  const [messagesWidth, setMessagesWidth] = useState<number | null>(null)

  const messages = [
    translate('Marquee.message.1'),
    translate('Marquee.message.2'),
    translate('Marquee.message.3'),
    translate('Marquee.message.4'),
    translate('Marquee.message.5'),
    translate('Marquee.message.6'),
    translate('Marquee.message.7'),
    translate('Marquee.message.8')
  ]

  useEffect(() => {
    const onResize = () => {
      if (!ref.current) {
        return
      }

      setMessagesWidth(ref.current.clientWidth)
    }

    onResize()
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return (
    <div className="Marquee">
      <p
        ref={ref}
        style={
          messagesWidth
            ? {
                width: `${messagesWidth}px`,
                textShadow: `${messagesWidth}px 0 currentColor, ${
                  messagesWidth * 2
                }px 0 currentColor, ${messagesWidth * 3}px 0 currentColor, ${
                  messagesWidth * 4
                }px 0 currentColor`
              }
            : {}
        }
      >
        {messages.map((message, index) => (
          <span key={index}>
            {index === 0 ? <strong>{message}</strong> : message}
            <span className="spacing" />
          </span>
        ))}
      </p>
    </div>
  )
}
